import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../../data/flyzone";

export const Reviews = () => {
  return (
    <section id="reviews" className="relative py-20 sm:py-28 bg-[#0D0D0D] border-y border-white/5 grain overflow-hidden">
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <span className="text-primary font-semibold text-sm uppercase tracking-widest">Customer Reviews</span>
          <h2 className="mt-3 text-3xl sm:text-5xl font-display font-bold tracking-tight">
            Loved by thousands of riders
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              data-testid={`review-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 4) * 0.08 }}
              className="relative rounded-2xl p-6 bg-[#141414] border border-white/10 flex flex-col"
            >
              <Quote className="w-8 h-8 text-primary/30 mb-3" />
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-primary fill-primary" />
                ))}
              </div>
              <p className="text-sm text-white/75 leading-relaxed flex-1">"{r.text}"</p>
              <div className="mt-5 flex items-center gap-3">
                <img src={r.avatar} alt={r.name} className="w-11 h-11 rounded-full object-cover border border-primary/30" />
                <div>
                  <div className="font-semibold text-sm">{r.name}</div>
                  <div className="text-xs text-white/50">{r.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
